import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Noise from "@/components/site/Noise";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import ProgramsPage from "@/pages/ProgramsPage";
import LeadershipPage from "@/pages/LeadershipPage";
import MathTutoringPage from "@/pages/MathTutoringPage";
import ArtPage from "@/pages/ArtPage";
import BooksPage from "@/pages/BooksPage";
import ApparelPage from "@/pages/ApparelPage";
import GalleryPage from "@/pages/GalleryPage";
import ManifestoPage from "@/pages/ManifestoPage";
import AuthorPage from "@/pages/AuthorPage";
import EnrollPage from "@/pages/EnrollPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // OAuth callback: process session_id FIRST, before any route/auth checks
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/leadership-training" element={<LeadershipPage />} />
        <Route path="/math-tutoring" element={<MathTutoringPage />} />
        <Route path="/art" element={<ArtPage />} />
        <Route path="/books" element={<BooksPage />} />
        <Route path="/apparel" element={<ApparelPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/manifesto" element={<ManifestoPage />} />
        <Route path="/author" element={<AuthorPage />} />
        <Route path="/enroll" element={<EnrollPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-body">
      <Noise />
      <AuthProvider>
        <HelmetProvider>
        <BrowserRouter>
          <SmoothScroll />
          <AppRouter />
        </BrowserRouter>
        </HelmetProvider>
        <Toaster position="bottom-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
